


import { Packages } from '../../../models/packages';
import { Materials } from '../../../models/materials';

import  '../templates/packageDetail.scss';


export class PackageDetailController implements ng.IController {

    static $inject = ['$mdMedia'];
    _iconValue: string[] = [];
  
    previousIndexExpanded: number = -1;

    constructor(private _$mdMedia: angular.material.IMedia) {
        
    }

    requestPackages: Packages;

    $onInit() { }

    itemClick(currentIndex : number): void {
        this.resetExpansionValues(currentIndex);
    }

    private resetExpansionValues(currentIndex : number): void {

        if (this.previousIndexExpanded === currentIndex) {
            if (this._iconValue[this.previousIndexExpanded] === this._iconValue[currentIndex]) {
                if (this._iconValue[this.previousIndexExpanded] === 'keyboard_arrow_down') {
                    this._iconValue[currentIndex] = 'keyboard_arrow_up';
                } else if (this._iconValue[this.previousIndexExpanded] === 'keyboard_arrow_up'){
                    this._iconValue[currentIndex] = 'keyboard_arrow_down';
                }
            } 
        } else {
            
            this.previousIndexExpanded = currentIndex;
            this._iconValue[currentIndex] = 'keyboard_arrow_down';
        }

       

    }


    get isSubScrollContainer(): boolean {
        return this._$mdMedia('gt-md');
    }

    get isScrollContainer(): boolean {
        return this._$mdMedia('sm') || this._$mdMedia('md');
    }

    dimension(len:string, width :string, height : string, uom : string): string {
        return len + 'L x' + width + 'W x' + height + 'H ' + uom;
    }

    iconValue(currentIndex: number): string {
       
        if (this._iconValue[currentIndex] === undefined) {
            this._iconValue[currentIndex] = 'keyboard_arrow_up';
            return 'keyboard_arrow_up';
        } else {
            return this._iconValue[currentIndex];
        }
    }

    isPackageTypeEnvelope(packageType: string): boolean {
        if (packageType !== undefined && packageType !== null && packageType.toLocaleLowerCase() === "envelope")
            return true;
        return false;
    }

    isExpanded(currentIndex: number): boolean {
        
        return (this._iconValue[currentIndex] !== undefined && this._iconValue[currentIndex] === 'keyboard_arrow_down');
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetail/directives/packageDetail/controllers/packageDetailController.ts
 **/